<template>
  <el-container>
    <el-header>
      <el-row :gutter="10">
        <el-col :xs="8" :sm="6" :md="4" :lg="10">
          <div class="grid-content bg-purple">
            <img src="../assets/logo.png" style="margin-top:5px" /> 
          </div>
        </el-col>
        <el-col :xs="4" :sm="6" :md="8" :lg="10">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">处理中心</el-menu-item>
            <el-menu-item index="3"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>
          </el-menu>
        </el-col>
        <el-col :xs="4" :sm="6" :md="4" :lg="3"><div class="grid-content bg-purple">3</div></el-col>
</el-row>
      <!-- <el-col :span="6" class="logo">
        <img src="../assets/logo.png" style="margin-top:5px" /> 
      </el-col>
      <el-col :span="14" class="menu-center">
        <el-menu :default-active="activeIndex"  mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">处理中心</el-menu-item>
          <el-menu-item index="3"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="4" class="menu-left">
        <el-menu>
          <el-menu-item index="1">中汇商联</el-menu-item>
        </el-menu>
      </el-col> -->
    </el-header>
    <el-main>Main</el-main>
    <el-footer>Footer</el-footer>
</el-container>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .menu-left {
    float:right;
    /*padding-right: 10%;*/
  }
  .menu-center {
    /*float:right;*/
    /*padding-left: 30%;*/
  }
  .logo {
    /*padding-left: 10%;*/

  }
/*h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue